'use client'

import { useRouter } from 'next/navigation'
import { buildUrl } from '../helpers'

export const InStockFilter = ({
  currentBrand,
  sortSlug,
  inStock,
}: InStockFilterProps) => {
  const router = useRouter()

  const handleInStockChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const willShowAll = !e.target.checked // Checked = in-stock only, unchecked = show all
    const newUrl = buildUrl(currentBrand, sortSlug, willShowAll, 1)
    router.push(newUrl)
  }

  return (
    <div className="flex items-center whitespace-nowrap">
      <input
        type="checkbox"
        id="in-stock-filter"
        checked={inStock}
        onChange={handleInStockChange}
        className="h-4 w-4 text-vi-red focus:ring-vi-red border-gray-300 rounded cursor-pointer"
      />
      <label
        htmlFor="in-stock-filter"
        className="ml-2 block text-sm text-gray-700 cursor-pointer"
      >
        Only show in stock decks
      </label>
    </div>
  )
}

interface InStockFilterProps {
  currentBrand: string
  sortSlug: string
  inStock: boolean
}

